<template>
	<div class="wrap-layer">
		<light-header :back="'/user-space/contracts?status=all'"></light-header>
		<div class="steps">
			<div class="step">
				<span class="circle">
					<i class="el-icon-check" style="color: #3699FF;font-weight: bold"></i>
				</span>
				选择套餐
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step">
				<span class="circle"><i class="el-icon-check" style="color: #3699FF;font-weight: bold"></i></span>
				在线支付
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step active">
				<span class="circle">3</span>
				完成
			</div>
		</div>
		<div class="feedback auto">
			<img class="success-img" src="../../assets/images/cart/pay-success.png" alt="">
			<div class="tip" >
				{{ msg }}
			</div>
		</div>
	</div>
</template>
<script>
	import lightHeader from "../../components/lightHeader";
	import { getOrderByOrderId } from "@/api/cart/cart";
	export default {
		components: {
			lightHeader
		},
		data() {
			return {
				audit: "no",
				orderId: "",
				msg: ""
			};
		},

		created() {
			this.audit = this.$route.query.audit;
			this.orderId = this.$route.query.orderId;
		},
		mounted() {
			if(this.orderId){
				let data = {orderId : this.orderId}
				console.log(this.orderId)
				getOrderByOrderId(data)
						.then(res => {
							if (res.code === 200) {
								let status = res.data.status;
								if(status != 'pay'){
									this.msg = "订单支付失败";
								}else{
									this.msg = "订单支付完成";
								}
							} else {
								this.$notify({
									title: res.message,
									type: "warning",
									duration: 2500
								});
							}
						})
						.catch(err => {
							this.payLoading = false;
							this.$notify({
								title: "未获取到订单信息",
								type: "error",
								duration: 2500
							});
						});
			}else{
				this.msg = "打款回单提交成功，请等待平台审核（注：工作日当天审核完成，节假日顺延至工作日审核完成）";
			}


		},
		methods: {}
	};
</script>
<style lang="scss">
	.steps {
		width: 441px;
		margin: 20px auto;
		display: flex;
		justify-content: space-around;
		align-items: center;
		.step {
			font-size: 16px;
			font-weight: 400;
			color: #333333;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.circle {
				display: block;
				width: 34px;
				height: 34px;
				border: 1px solid #dedcdb;
				border-radius: 50%;
				text-align: center;
				line-height: 34px;
				font-weight: 400;
				color: #c3c3c3;
				font-size: 16px;
				margin-right: 12px;
			}
			&.active {
				.circle {
					background: #3296fa;
					color: #fff;
				}
				color: #3699ff;
				border: none;
			}
		}
	}
</style>
<style lang="scss" scoped>
	.wrap-layer {
		background: #f0f0f5;
		height: 100vh;
		.feedback {
			background: #fff;
			padding: 150px 30px 50px;
			height: calc(100vh - 145px);
			text-align: center;
			.success-img {
				width: 200px;
				height: auto;
				display: block;
				margin: 0 auto;
			}
		}
		.tip {
			display: block;
			text-align: center;
			margin: 52px auto 0;
			font-size: 16px;
			font-weight: 400;
			color: #333333;
		}
	}
</style>
